import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { PLATFORMS } from '@constants/platforms';
import { useTranslationResponse as t } from '@isomorphic/hooks/use-translation-response';

export const useCurrentPlatform = () => {
  const router = useRouter();
  const platforms = [t('403PlayStation5'), t('403PlayStation4'), t('403Xbox'), t('403Nintendo'), t('403Nintendo2')];
  const platformsFromQuery = PLATFORMS;
  const [platform, setPlatform] = useState<string>('');

  useEffect(() => {
    const currentPlatform = router.query.platform || platformsFromQuery[0];
    const currentPlatformIndex = platformsFromQuery.findIndex((platform) => platform === currentPlatform);
    setPlatform(platforms[currentPlatformIndex]);
  }, [platforms]);

  return platform;
};
